import UnitProjectMaterialsTable from './UnitProjectMaterialsTable';

export default UnitProjectMaterialsTable;
